// extracted by mini-css-extract-plugin
export default {"aboutme_dark":"About_aboutme_dark__usyXs","aboutme_light":"About_aboutme_light__ppb2X"};